import React from 'react';
import { Button, Input, Row, Spin, Typography } from 'antd';
import { PasswordResetProps } from '../../interfaces';
import { formatTime } from './passwordResetUtils';

const { Title, Text } = Typography;

const PasswordReset = ({ email, passwordReset }: PasswordResetProps) => (
  <>
    <Title level={5}>Reset Password</Title>
    <div className="user-profile__reset-target">
      <Text>Send reset code to: </Text>
      <Text>{email}</Text>
    </div>

    <Row className="user-profile__reset-action">
      <Button
        type="primary"
        onClick={passwordReset.handleSendResetEmail}
        disabled={passwordReset.resetPasswordLoading || !email}
        aria-label={passwordReset.resetPasswordLoading ? 'Sending reset code' : 'Send Code'}
        aria-busy={passwordReset.resetPasswordLoading}
      >
        {passwordReset.resetPasswordLoading ? <Spin size="small" aria-hidden="true" /> : 'Send Code'}
      </Button>
    </Row>

    {passwordReset.tokenSent && (
      <>
        <div className="user-profile__field">
          <label htmlFor="reset-token">Enter code from email</label>
          <Input
            id="reset-token"
            placeholder="000000"
            value={passwordReset.token}
            onChange={(event) => passwordReset.setToken(event.target.value)}
          />
        </div>

        {passwordReset.timer === 0 && (
          <div className="user-profile__expired-code">
            Code expired. Send a new code and try again.
          </div>
        )}

        <div className="user-profile__field">
          <label htmlFor="new-password">Enter new password</label>
          <Input.Password
            id="new-password"
            placeholder="Enter new password"
            value={passwordReset.newPassword}
            onChange={passwordReset.handleChangePassword}
            style={passwordReset.passwordStyle}
          />
        </div>

        <div className="user-profile__field">
          <label htmlFor="confirm-password">Confirm new password</label>
          <Input.Password
            id="confirm-password"
            placeholder="Confirm new password"
            value={passwordReset.confirmPassword}
            onChange={(event) => passwordReset.setConfirmPassword(event.target.value)}
          />
        </div>

        <Row justify="space-between" align="middle">
          <Button
            type="primary"
            onClick={passwordReset.handlePasswordResetByToken}
            disabled={passwordReset.resetPasswordLoading || passwordReset.timer === 0}
            aria-label={passwordReset.resetPasswordLoading ? 'Changing password' : 'Change Password'}
            aria-busy={passwordReset.resetPasswordLoading}
          >
            {passwordReset.resetPasswordLoading ? <Spin size="small" aria-hidden="true" /> : 'Change Password'}
          </Button>
          {passwordReset.timer > 0 && <span>{formatTime(passwordReset.timer)}</span>}
        </Row>
      </>
    )}
  </>
);

export default PasswordReset;
